import { useState } from "react";
import { toast } from "sonner";
import { api, formatApiError } from "@/lib/api";
import { reorderItems } from "@/components/Sortable";

export const useShopBoard = (shops) => {
  const [dragItem, setDragItem] = useState(null);
  const [overList, setOverList] = useState(null);
  const listOf = (id) => {
    if (!id) return null;
    const s = String(id);
    return s.startsWith("list:") ? s.slice(5) : shops.data.find((l) => l.items.some((i) => i.id === s))?.id;
  };

  const onDragStart = ({ active }) => setDragItem(shops.data.flatMap((l) => l.items).find((i) => i.id === active.id) || null);
  const onDragOver = ({ active, over }) => {
    const dst = listOf(over?.id);
    setOverList(dst && dst !== listOf(active.id) ? dst : null);
  };
  const onDragEnd = async ({ active, over }) => {
    setDragItem(null);
    setOverList(null);
    if (!active || !over) return;
    const src = shops.data.find((l) => l.id === listOf(active.id));
    const dst = shops.data.find((l) => l.id === listOf(over.id));
    if (!src || !dst) return;
    const overIsList = String(over.id).startsWith("list:");
    if (src.id === dst.id) {
      if (!overIsList && active.id !== over.id) reorderItems(`/shop-lists/${src.id}`, src, active.id, over.id, shops.replace);
      return;
    }
    const item = src.items.find((i) => i.id === active.id);
    const index = overIsList ? dst.items.length : dst.items.findIndex((i) => i.id === over.id);
    const nextDst = [...dst.items];
    nextDst.splice(index, 0, item);
    shops.replace({ ...src, items: src.items.filter((i) => i.id !== item.id) });
    shops.replace({ ...dst, items: nextDst });
    try {
      const r = await api.post(`/shop-lists/${src.id}/items/${item.id}/move`, { target_list_id: dst.id, index });
      shops.replace(r.data.source);
      shops.replace(r.data.target);
      toast.success(`Moved "${item.name}" to ${dst.name}`);
    } catch (e) {
      shops.replace(src);
      shops.replace(dst);
      toast.error(`Couldn't move "${item.name}": ${formatApiError(e)}`);
      shops.reload();
    }
  };

  return { dragItem, overList, handlers: { onDragStart, onDragOver, onDragEnd } };
};
